import { TabPanel, Toolbar } from "devextreme-react";
import { Item as TabPanelItem } from "devextreme-react/tab-panel";
import { Item } from "devextreme-react/toolbar";
import React from "react";
import ContractForm from "./ContractForm";
import DivisionInformation from "./DivisionInformation";
import JobInformation from "./JobInformation";
import JoinLeaveInformation from "./JoinLeaveInformation";
import LeaveOfAbsenceInformation from "./LeaveOfAbsenceInformation";

export default function PersonnelInformation() {
  return (
    <React.Fragment>
      <Toolbar>
        <Item location={"before"}>
          <span
            style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}
          >
            PERSONNEL INFORMATION
          </span>
        </Item>
      </Toolbar>
      <TabPanel id="personnelInfoTabPanel" deferRendering={false}>
        {/* <TabPanelItem title="입/퇴사 정보"> */}
        <TabPanelItem title="EMPLOYMENT/RESIGNATION INFO.">
          <JoinLeaveInformation />
        </TabPanelItem>
        <TabPanelItem title="LEAVE OF ABSENCE INFO.">
          <LeaveOfAbsenceInformation />
        </TabPanelItem>
        {/* <TabPanelItem title="부서정보"> */}
        <TabPanelItem title="DEPARTMENT INFO.">
          <DivisionInformation />
        </TabPanelItem>
        {/* <TabPanelItem title="직무정보"> */}
        <TabPanelItem title="JOB INFO.">
          <JobInformation />
        </TabPanelItem>
        {/* <TabPanelItem title="계약형태"> */}
        <TabPanelItem title="Contract Type">
          <ContractForm />
        </TabPanelItem>
        {/* <TabPanelItem title="근무시간"></TabPanelItem> */}
      </TabPanel>
    </React.Fragment>
  );
}
